import Item from '../../canvas-timeline/canvas_timeline_item';
import {ITEM_TYPE, COMMON_IMAGE} from '../../canvas-timeline/canvas_timeline_util';
import {cacheManager} from '../../canvas-timeline/canvas_timeline_cache_manager';

class FreeDayItem extends Item {
	constructor(data) {
		super(ITEM_TYPE.PEOPLE_SCHEDULING_HEATMAP, data);
	}

	// FreeDayItem is an empty element that allows for the diagobal lines pattern to be visible
	draw(canvasContext) {
		const {data} = this;
		const {x, y, width, groupHeight, isDefaultFreeDay} = data;

		// if !isDefaultFreeDay (not weekend nor holiday from the company default calendar but custom user calendar holiday) draw the line pattern
		if (!isDefaultFreeDay) {
			const pattern = canvasContext.createPattern(cacheManager.getCommonImageSafariWorkaround(COMMON_IMAGE.FREEDAY), 'repeat');
			canvasContext.fillStyle = pattern;
			canvasContext.fillRect(x, y, width, groupHeight);
		}
	}
}
export default FreeDayItem;
